import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 18 16',
    fill: 'currentColor',
    defaultAriaLabel: 'Gallery View Icon',
};

export const GalleryViewStyleIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <rect y="0.5" width="7.5" height="6" />
            <rect y="9.5" width="7.5" height="6" />
            <rect x="10.5" y="0.5" width="7.5" height="6" />
            <rect x="10.5" y="9.5" width="7.5" height="6" />
        </SvgIcon>
    );
};
